export type WarehouseRow = {
  key: string;
  name: string;
  type: string;
  location: string;
  storageLimit: string;
  monthlyFee: number;
  longTermFee: number;
};

export const warehouseData: WarehouseRow[] = [
  {
    key: "WH1",
    name: "Warehouse Name",
    type: "FBA",
    location: "87 Vernon Tce, EC8B 1BE",
    storageLimit: "20D",
    monthlyFee: 350,
    longTermFee: 30,
  },
  {
    key: "WH2",
    name: "Warehouse Name",
    type: "FBA",
    location: "87 Vernon Tce, EC8B 1BE",
    storageLimit: "20D",
    monthlyFee: 350,
    longTermFee: 30,
  },
  {
    key: "WH3",
    name: "Warehouse Name",
    type: "FBA",
    location: "87 Vernon Tce, EC8B 1BE",
    storageLimit: "20D",
    monthlyFee: 350,
    longTermFee: 30,
  },
];
